import { expVal } from '@atlassian/jira-feature-experiments';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	get(): boolean {
		return expVal('jira_improve_code_page_empty_state', 'isEnabled', false);
	},
};
